import { PaymentMethod, UISubscriptionStatus } from "common/types";

import { useCreatePaymentMethodMutation } from "client/payments/hooks";
import PaymentForm from "client/payments/components/PaymentForm";
import { useSubscriptionsQuery } from "client/subscriptions/hooks";
import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCurrentDrawer } from "client/common/hooks/stackables";
import { useSubscriptionBulkUpdatePaymentMethodDrawer } from "client/subscriptions/stackables";

const AccountCreatePaymentDrawer = () => {
  const { close } = useCurrentDrawer();
  const { data: subscriptions = [], isLoading: isSubscriptionsLoading } = useSubscriptionsQuery({
    visible_status: [
      UISubscriptionStatus.Active,
      UISubscriptionStatus.Paused,
      UISubscriptionStatus.FailedPayment,
    ],
  });

  const { open: openSubscriptionBulkUpdatePaymentMethodDrawer } =
    useSubscriptionBulkUpdatePaymentMethodDrawer();
  const onCreatePaymentMethodSuccess = (paymentMethod: PaymentMethod) => {
    if (subscriptions?.length >= 1) {
      openSubscriptionBulkUpdatePaymentMethodDrawer({
        paymentMethod,
        subscriptions,
        onSuccess: close,
      });
    } else {
      close();
    }
  };
  const {
    mutate: createPaymentMethod,
    isLoading: isCreatingPaymentMethod,
    error,
  } = useCreatePaymentMethodMutation({
    onSuccess: onCreatePaymentMethodSuccess,
  });

  if (isSubscriptionsLoading) {
    return <DrawerLayout.Loading />;
  }

  return (
    <DrawerLayout>
      <DrawerLayout.Header title="Add payment method" onClose={close} />
      <PaymentForm
        isLoading={isCreatingPaymentMethod || isSubscriptionsLoading}
        onSubmit={(id) => createPaymentMethod({ payment_method: id })}
        error={error}
      />
    </DrawerLayout>
  );
};

export default AccountCreatePaymentDrawer;
